/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityCustomTag } from './FacilityCustomTag';
import {
    FacilityCustomTagFromJSON,
    FacilityCustomTagFromJSONTyped,
    FacilityCustomTagToJSON,
} from './FacilityCustomTag';

/**
 * 
 * @export
 * @interface CreateFacilityCustomTag201Response
 */
export interface CreateFacilityCustomTag201Response {
    /**
     * 
     * @type {FacilityCustomTag}
     * @memberof CreateFacilityCustomTag201Response
     */
    data?: FacilityCustomTag;
}

/**
 * Check if a given object implements the CreateFacilityCustomTag201Response interface.
 */
export function instanceOfCreateFacilityCustomTag201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFacilityCustomTag201ResponseFromJSON(json: any): CreateFacilityCustomTag201Response {
    return CreateFacilityCustomTag201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityCustomTag201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityCustomTag201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilityCustomTagFromJSON(json['data']),
    };
}

export function CreateFacilityCustomTag201ResponseToJSON(value?: CreateFacilityCustomTag201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilityCustomTagToJSON(value.data),
    };
}

